<template>
  <base-dialog :value="isShown"
               :title="dialogTitle"
               text="This action is irreversible and cannot be undone."
               :is-primary-button-busy="isLoading"
               hide-btn
               @cancel="handleCancel"
  >
    <template #prompt-input>
      <settings-bot-market-form v-if="hasAvailableMarketOptions"
                                v-model="marketForm"
                                :multi-bots="multiBots"
                                :existing-only="true"
                                market-select-label="Select primary market"
      />
      <p v-else class="mt-4 text-gray-dark">
        <template v-if="showUnreleased">
          No markets available. <router-link :to="{ name: 'markets' }">Manage markets in Settings &gt; Markets</router-link>.
        </template>
        <template v-else>
          No markets available yet.
        </template>
      </p>
    </template>

    <template #confirm-button>
      <base-button variant="bordered"
                   class="w-full justify-center"
                   :disabled="isLoading"
                   @click="handleCancel"
      >
        Cancel
      </base-button>
      <busy-button id="convertToMultiMarketButton"
                   variant="primary"
                   class="w-full ml-4"
                   :is-loading="isLoading"
                   :is-disabled="!hasAvailableMarketOptions || !isMarketFormValid || isLoading"
                   @click="submit"
      >
        Convert
      </busy-button>
    </template>
  </base-dialog>
</template>

<script>
import BusyButton from '@/components/common/BusyButton'
import BaseButton from '@/components/base-components/BaseButton.vue'
import SettingsBotMarketForm from '@/components/settings/bots/SettingsBotMarketForm.vue'
import botModule from '@/store/modules/bot.module'
import {
  createDefaultMarketForm,
  getAvailableMarketOptions,
  isMarketFormValid
} from '@/utils/market.utils'

export default {
  name: 'SettingsBotConvertToMultiMarketDialog',

  components: {
    BusyButton,
    BaseButton,
    SettingsBotMarketForm
  },

  props: {
    isShown: {
      type: Boolean,
      default: false
    },
    bot: {
      type: Object,
      default: null
    },
    multiBots: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  emits: ['cancel', 'convert'],

  data() {
    return {
      marketForm: createDefaultMarketForm({
        language: this.bot?.language,
        timezone: this.bot?.timezone
      })
    }
  },

  computed: {
    dialogTitle() {
      const botName = this.bot?.name || 'bot'
      return `Convert ${botName} to multi-market bot?`
    },
    bots() {
      return botModule.getBotList()
    },
    hasAvailableMarketOptions() {
      return getAvailableMarketOptions(this.multiBots).length > 0
    },
    isMarketFormValid() {
      return isMarketFormValid(this.marketForm, this.hasAvailableMarketOptions, this.bots)
    }
  },

  watch: {
    bot: {
      immediate: true,
      handler(bot) {
        this.marketForm = createDefaultMarketForm({
          language: bot?.language,
          timezone: bot?.timezone
        })
      }
    }
  },

  methods: {
    handleCancel() {
      this.$emit('cancel')
    },
    submit() {
      if (!this.isMarketFormValid) return
      this.$emit('convert', { ...this.marketForm })
    }
  }
}
</script>
